import ajax from './ajax';
import { ajaxErrorCatch } from '@/utils/errorCatch';
import { COMMON_INFO_URL } from '@/utils/api';

// 通用配置接口 getCommonInfo调用封装
export default async function fetchCommonInfo(body, callback) {
  const res = await ajaxErrorCatch(ajax.post(`${COMMON_INFO_URL}?kfuin=${body.kfuin}`, body));
  const { code, data } = res;
  if (code !== 0) return;
  callback && callback(data);
};
